import React from "react";
import { FaWhatsapp, FaPhone } from "react-icons/fa";
import "./FloatingCTA.css";

const WHATSAPP = "919392014678";
const PHONE = "+919392014678";
const WA_MSG = encodeURIComponent("Hi! I saw AI4Bazaar on social media and want a website for my business. Please share details.");

const FloatingCTA = () => (
  <div className="floating-cta" aria-label="Quick contact options">
    <a href={`https://wa.me/${WHATSAPP}?text=${WA_MSG}`} className="floating-btn floating-whatsapp" target="_blank" rel="noopener noreferrer" title="Chat on WhatsApp">
      <FaWhatsapp />
      <span>WhatsApp</span>
    </a>
    <a href={`tel:${PHONE}`} className="floating-btn floating-call" title="Call us">
      <FaPhone />
      <span>Call Now</span>
    </a>
  </div>
);

export default FloatingCTA;
